// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ImageGrid_imageWrapper__rxOn0"};